import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
} from "devextreme-react/data-grid";
// import moment from "moment";
import { formatMessage } from "devextreme/localization";
import { useSelector, useDispatch } from "react-redux";
import { showOvertimeSummary } from "../../../redux/actions";
import { responseOvertime } from "../../../redux/reducers";
import { useScreenSize } from "../../../utils/media-query";

import ToolbarBefore from "../../../components/toolbar-before/ToolbarBefore";
import ToolbarAfter from "./ToolbarAfter";
import { useAuth } from "../../../contexts/auth";

export default function OvertimeSummaryTableList({ dataGrid, middleware }) {
  const { user } = useAuth();
  const [year, setYear] = React.useState();
  const { isXSmall, isSmall } = useScreenSize();
  const dispatch = useDispatch();
  const { overtimeSummary } = useSelector(responseOvertime);

  const handleChangeSelectBox = async () => {
    const payload = {
      Year: Number(year),
      EmployeeOid: user?.EmployeeOid,
    };
    dispatch(showOvertimeSummary(payload));
  };
  return (
    <div>
      <DataGrid
        id="gridContainer"
        height={document.documentElement.offsetHeight - 189}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnHidingEnabled={true}
        ref={(e) => {
          dataGrid.current = e;
        }}
        dataSource={overtimeSummary}
      >
        {/* <SearchPanel
        visible={true}
        width={240}
        className="datagrid-toolbar-search-panel"
        placeholder="Search..."
      /> */}
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />
        <Column
          caption={formatMessage("EmployeeCode")}
          dataField="Employee.EmployeeCode"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("EmployeeName")}
          dataField="Employee.FullName"
          dataType="string"
        />
        <Column
          caption={formatMessage("DepartmentCode")}
          dataField="Employee.Department.DepartmentCode"
          dataType="string"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("DepartmentName")}
          dataField="Employee.Department.DepartmentName"
          dataType="string"
          hidingPriority={isXSmall ? 1 : false}
        />
        <Column
          caption={formatMessage("PositionName")}
          dataField="Employee.Position.PositionName"
          dataType="string"
        />
        <Column
          caption={formatMessage("Year")}
          dataField="Year"
          hidingPriority={isXSmall || isSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("M1")}
          dataField="M1"
          hidingPriority={isXSmall || isSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("M2")}
          dataField="M2"
          hidingPriority={isXSmall || isSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("M3")}
          dataField="M3"
          hidingPriority={isXSmall || isSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("M4")}
          dataField="M4"
          hidingPriority={isXSmall || isSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("M5")}
          dataField="M5"
          hidingPriority={isXSmall || isSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("M6")}
          dataField="M6"
          hidingPriority={isXSmall || isSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("M7")}
          dataField="M7"
          hidingPriority={isXSmall || isSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("M8")}
          dataField="M8"
          hidingPriority={isXSmall || isSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("M9")}
          dataField="M9"
          hidingPriority={isXSmall || isSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("M10")}
          dataField="M10"
          hidingPriority={isXSmall || isSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("M11")}
          dataField="M11"
          hidingPriority={isXSmall || isSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("M12")}
          dataField="M12"
          hidingPriority={isXSmall || isSmall ? 2 : false}
        />
        <Column
          caption={formatMessage("TotalHours")}
          dataField="TotalHours"
          hidingPriority={isXSmall || isSmall ? 11 : false}
          alignment="center"
        />
        <Toolbar className="datagrid-toolbar-actions">
          <Item
            location="before"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarBefore
              middleware={middleware}
              dataGrid={dataGrid}
              setYear={setYear}
              handleChangeSelectBox={handleChangeSelectBox}
            />
          </Item>
          <Item
            location="after"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarAfter middleware={middleware} dataGrid={dataGrid} />
          </Item>
        </Toolbar>
      </DataGrid>
    </div>
  );
}
